/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  HangarStats,
  HangarStatsParams,
  PieChartStats,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Your Hangar Stats
 */
export const hangarStats = (
    params?: MaybeRefOrGetter<HangarStatsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<HangarStats>(
      {url: `/hangar/stats`, method: 'GET',
        params, signal
    },
      );
    }




export const getHangarStatsQueryKey = (params?: MaybeRefOrGetter<HangarStatsParams>,) => {
    return [
    'hangar','stats', ...(params ? [params] : [])
    ] as const;
    }


export const getHangarStatsQueryOptions = <TData = Awaited<ReturnType<typeof hangarStats>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<HangarStatsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarStats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarStatsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarStats>>> = ({ signal }) => hangarStats(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarStats>>, TError, TData>
}

export type HangarStatsQueryResult = NonNullable<Awaited<ReturnType<typeof hangarStats>>>
export type HangarStatsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Your Hangar Stats
 */

export function useHangarStats<TData = Awaited<ReturnType<typeof hangarStats>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<HangarStatsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarStats>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarStatsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Hangar Stats - Models by Classification
 */
export const hangarModelsByClassification = (

 signal?: AbortSignal
) => {


      return axiosClient<PieChartStats[]>(
      {url: `/hangar/stats/models-by-classification`, method: 'GET', signal
    },
      );
    }




export const getHangarModelsByClassificationQueryKey = () => {
    return [
    'hangar','stats','models-by-classification'
    ] as const;
    }


export const getHangarModelsByClassificationQueryOptions = <TData = Awaited<ReturnType<typeof hangarModelsByClassification>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarModelsByClassification>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarModelsByClassificationQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarModelsByClassification>>> = ({ signal }) => hangarModelsByClassification(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarModelsByClassification>>, TError, TData>
}

export type HangarModelsByClassificationQueryResult = NonNullable<Awaited<ReturnType<typeof hangarModelsByClassification>>>
export type HangarModelsByClassificationQueryError = ErrorType<StandardError>


/**
 * @summary Hangar Stats - Models by Classification
 */

export function useHangarModelsByClassification<TData = Awaited<ReturnType<typeof hangarModelsByClassification>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarModelsByClassification>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarModelsByClassificationQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Hangar Stats - Models by Manufacturer
 */
export const hangarModelsByManufacturer = (

 signal?: AbortSignal
) => {


      return axiosClient<PieChartStats[]>(
      {url: `/hangar/stats/models-by-manufacturer`, method: 'GET', signal
    },
      );
    }




export const getHangarModelsByManufacturerQueryKey = () => {
    return [
    'hangar','stats','models-by-manufacturer'
    ] as const;
    }


export const getHangarModelsByManufacturerQueryOptions = <TData = Awaited<ReturnType<typeof hangarModelsByManufacturer>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarModelsByManufacturer>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarModelsByManufacturerQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarModelsByManufacturer>>> = ({ signal }) => hangarModelsByManufacturer(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarModelsByManufacturer>>, TError, TData>
}

export type HangarModelsByManufacturerQueryResult = NonNullable<Awaited<ReturnType<typeof hangarModelsByManufacturer>>>
export type HangarModelsByManufacturerQueryError = ErrorType<StandardError>


/**
 * @summary Hangar Stats - Models by Manufacturer
 */

export function useHangarModelsByManufacturer<TData = Awaited<ReturnType<typeof hangarModelsByManufacturer>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarModelsByManufacturer>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarModelsByManufacturerQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Hangar Stats - Models by Production Status
 */
export const hangarModelsByProductionStatus = (

 signal?: AbortSignal
) => {


      return axiosClient<PieChartStats[]>(
      {url: `/hangar/stats/models-by-production-status`, method: 'GET', signal
    },
      );
    }




export const getHangarModelsByProductionStatusQueryKey = () => {
    return [
    'hangar','stats','models-by-production-status'
    ] as const;
    }


export const getHangarModelsByProductionStatusQueryOptions = <TData = Awaited<ReturnType<typeof hangarModelsByProductionStatus>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarModelsByProductionStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarModelsByProductionStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarModelsByProductionStatus>>> = ({ signal }) => hangarModelsByProductionStatus(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarModelsByProductionStatus>>, TError, TData>
}

export type HangarModelsByProductionStatusQueryResult = NonNullable<Awaited<ReturnType<typeof hangarModelsByProductionStatus>>>
export type HangarModelsByProductionStatusQueryError = ErrorType<StandardError>


/**
 * @summary Hangar Stats - Models by Production Status
 */

export function useHangarModelsByProductionStatus<TData = Awaited<ReturnType<typeof hangarModelsByProductionStatus>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarModelsByProductionStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarModelsByProductionStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Hangar Stats - Models by Size
 */
export const hangarModelsBySize = (

 signal?: AbortSignal
) => {


      return axiosClient<PieChartStats[]>(
      {url: `/hangar/stats/models-by-size`, method: 'GET', signal
    },
      );
    }




export const getHangarModelsBySizeQueryKey = () => {
    return [
    'hangar','stats','models-by-size'
    ] as const;
    }


export const getHangarModelsBySizeQueryOptions = <TData = Awaited<ReturnType<typeof hangarModelsBySize>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarModelsBySize>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarModelsBySizeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarModelsBySize>>> = ({ signal }) => hangarModelsBySize(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarModelsBySize>>, TError, TData>
}

export type HangarModelsBySizeQueryResult = NonNullable<Awaited<ReturnType<typeof hangarModelsBySize>>>
export type HangarModelsBySizeQueryError = ErrorType<StandardError>


/**
 * @summary Hangar Stats - Models by Size
 */

export function useHangarModelsBySize<TData = Awaited<ReturnType<typeof hangarModelsBySize>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarModelsBySize>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarModelsBySizeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






